const _temp0 = require("./style/_layout.styl");
module.exports = {
  "_layout": _temp0
}